(function () {
  var SECTION_SELECTOR = '.oddit-section-faq';

  function initSection(section) {
    if (!section || section.dataset.odditFaqInit === 'true') return;
    section.dataset.odditFaqInit = 'true';

    var triggers = section.querySelectorAll('[data-faq-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('[data-faq-item]');
        if (!item) return;

        var answer = item.querySelector('[data-faq-answer]');
        if (!answer) return;

        var isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (isOpen) {
          trigger.setAttribute('aria-expanded', 'false');
          answer.setAttribute('aria-hidden', 'true');
          answer.setAttribute('hidden', '');
        } else {
          trigger.setAttribute('aria-expanded', 'true');
          answer.setAttribute('aria-hidden', 'false');
          answer.removeAttribute('hidden');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();